import React from 'react';
import styles from './yotiCircle.module.scss';

const YotiCircle: React.FC = () => {
    return <div className={styles['yoti-circle']}></div>;
};

export default YotiCircle;
